import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { useNavPermissions } from '../hooks/useNavPermissions';

function Header() {
  const { user } = useAuth();
  const { hasWorkFeatures, hasLifeFeatures } = useNavPermissions();

  // Eingeloggt + Features → aktiv (LED an, Bereich öffnen)
  // Eingeloggt + keine Features → deaktiviert (LED aus, Button gesperrt)
  // Nicht eingeloggt → LED aus, Login-Redirect
  const workOn       = !!(user && hasWorkFeatures);
  const lifeOn       = !!(user && hasLifeFeatures);
  const workDisabled = !!(user && !hasWorkFeatures);
  const lifeDisabled = !!(user && !hasLifeFeatures);
  // Eingeloggte Life-Nutzer landen im /life Shell, andere im /dashboard

  return (
    <header>
      <div className="header-content">
        <Link to="/" className="logo">techsoul</Link>
        <nav>
          <a href="#work">TechSoul Work</a>
          <a href="#life">TechSoul Life</a>
          <a href="#ueber">Über TechSoul</a>
          <a href="#beratung">Beratung</a>
          <Link to="/coaching">Coaching</Link>
          <a href="#contact">Kontakt</a>

          <div className="header-cta-group">

            {/* ── Work-Button ── */}
            {workDisabled ? (
              <span className="btn-login btn-login--work btn-login--disabled">
                <span className="header-led header-led--off" />
                🚀 Work
              </span>
            ) : (
              <Link
                to={workOn ? '/work' : '/login'}
                state={workOn ? undefined : { from: { pathname: '/work' } }}
                className="btn-login btn-login--work"
              >
                <span className={`header-led ${workOn ? 'header-led--on header-led--work' : 'header-led--off'}`} />
                🚀 Work
              </Link>
            )}

            {/* ── Life-Button ── */}
            {lifeDisabled ? (
              <span className="btn-login btn-login--life btn-login--disabled">
                <span className="header-led header-led--off" />
                ✨ Life
              </span>
            ) : (
              <Link
                to={lifeOn ? '/life' : '/login'}
                state={lifeOn ? undefined : { from: { pathname: '/life' } }}
                className="btn-login btn-login--life"
              >
                <span className={`header-led ${lifeOn ? 'header-led--on header-led--life' : 'header-led--off'}`} />
                ✨ Life
              </Link>
            )}

          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
